// frontend/src/config/nigerianLocations.js

export const NIGERIAN_STATES = [
  {
    id: 'ABIA',
    name: 'Abia',
    lgas: [
      'Aba North', 'Aba South', 'Arochukwu', 'Bende', 'Ikwuano',
      'Isiala Ngwa North', 'Isiala Ngwa South', 'Isuikwuato',
      'Obi Ngwa', 'Ohafia', 'Osisioma', 'Ugwunagbo',
      'Ukwa East', 'Ukwa West', 'Umuahia North', 'Umuahia South',
      'Umu Nneochi'
    ]
  },
  {
    id: 'ADAMAWA',
    name: 'Adamawa',
    lgas: [
      'Demsa', 'Fufure', 'Ganye', 'Gayuk', 'Gombi', 'Grie',
      'Hong', 'Jada', 'Lamurde', 'Madagali', 'Maiha', 'Mayo Belwa',
      'Michika', 'Mubi North', 'Mubi South', 'Numan', 'Shelleng',
      'Song', 'Toungo', 'Yola North', 'Yola South'
    ]
  },
  {
    id: 'AKWA_IBOM',
    name: 'Akwa Ibom',
    lgas: [
      'Abak', 'Eastern Obolo', 'Eket', 'Esit Eket', 'Essien Udim',
      'Etim Ekpo', 'Etinan', 'Ibeno', 'Ibesikpo Asutan',
      'Ibiono Ibom', 'Ika', 'Ikono', 'Ikot Abasi', 'Ikot Ekpene',
      'Ini', 'Itu', 'Mbo', 'Mkpat Enin', 'Nsit Atai', 'Nsit Ibom',
      'Nsit Ubium', 'Obot Akara', 'Okobo', 'Onna', 'Oron',
      'Oruk Anam', 'Udung Uko', 'Ukanafun', 'Uruan',
      'Urue Offong/Oruko', 'Uyo'
    ]
  },
  {
    id: 'ANAMBRA',
    name: 'Anambra',
    lgas: [
      'Aguata', 'Anambra East', 'Anambra West', 'Anaocha',
      'Awka North', 'Awka South', 'Ayamelum', 'Dunukofia',
      'Ekwusigo', 'Idemili North', 'Idemili South', 'Ihiala',
      'Njikoka', 'Nnewi North', 'Nnewi South', 'Ogbaru',
      'Onitsha North', 'Onitsha South', 'Orumba North',
      'Orumba South', 'Oyi'
    ]
  },
  {
    id: 'BAUCHI',
    name: 'Bauchi',
    lgas: [
      'Alkaleri', 'Bauchi', 'Bogoro', 'Damban', 'Darazo',
      'Dass', 'Gamawa', 'Ganjuwa', 'Giade', 'Itas/Gadau',
      "Jama'are", 'Katagum', 'Kirfi', 'Misau', 'Ningi',
      'Shira', 'Tafawa Balewa', 'Toro', 'Warji', 'Zaki'
    ]
  },
  {
    id: 'BAYELSA',
    name: 'Bayelsa',
    lgas: [
      'Brass', 'Ekeremor', 'Kolokuma/Opokuma', 'Nembe',
      'Ogbia', 'Sagbama', 'Southern Ijaw', 'Yenagoa'
    ]
  },
  {
    id: 'BENUE',
    name: 'Benue',
    lgas: [
      'Ado', 'Agatu', 'Apa', 'Buruku', 'Gboko', 'Guma',
      'Gwer East', 'Gwer West', 'Katsina Ala', 'Konshisha',
      'Kwande', 'Logo', 'Makurdi', 'Obi', 'Ogbadibo',
      'Ohimini', 'Oju', 'Okpokwu', 'Oturkpo', 'Tarka',
      'Ukum', 'Ushongo', 'Vandeikya'
    ]
  },
  {
    id: 'BORNO',
    name: 'Borno',
    lgas: [
      'Abadam', 'Askira/Uba', 'Bama', 'Bayo', 'Biu', 'Chibok',
      'Damboa', 'Dikwa', 'Gubio', 'Guzamala', 'Gwoza', 'Hawul',
      'Jere', 'Kaga', 'Kala/Balge', 'Konduga', 'Kukawa',
      'Kwaya Kusar', 'Mafa', 'Magumeri', 'Maiduguri', 'Marte',
      'Mobbar', 'Monguno', 'Ngala', 'Nganzai', 'Shani'
    ]
  },
  {
    id: 'CROSS_RIVER',
    name: 'Cross River',
    lgas: [
      'Abi', 'Akamkpa', 'Akpabuyo', 'Bakassi', 'Bekwarra',
      'Biase', 'Boki', 'Calabar Municipal', 'Calabar South',
      'Etung', 'Ikom', 'Obanliku', 'Obubra', 'Obudu',
      'Odukpani', 'Ogoja', 'Yakuur', 'Yala'
    ]
  },
  {
    id: 'DELTA',
    name: 'Delta',
    lgas: [
      'Aniocha North', 'Aniocha South', 'Bomadi', 'Burutu',
      'Ethiope East', 'Ethiope West', 'Ika North East',
      'Ika South', 'Isoko North', 'Isoko South',
      'Ndokwa East', 'Ndokwa West', 'Okpe', 'Oshimili North',
      'Oshimili South', 'Patani', 'Sapele', 'Udu',
      'Ughelli North', 'Ughelli South', 'Ukwuani', 'Uvwie',
      'Warri North', 'Warri South', 'Warri South West'
    ]
  },
  {
    id: 'EBONYI',
    name: 'Ebonyi',
    lgas: [
      'Abakaliki', 'Afikpo North', 'Afikpo South', 'Ebonyi',
      'Ezza North', 'Ezza South', 'Ikwo', 'Ishielu', 'Ivo',
      'Izzi', 'Ohaozara', 'Ohaukwu', 'Onicha'
    ]
  },
  {
    id: 'EDO',
    name: 'Edo',
    lgas: [
      'Akoko Edo', 'Egor', 'Esan Central', 'Esan North East',
      'Esan South East', 'Esan West', 'Etsako Central',
      'Etsako East', 'Etsako West', 'Igueben', 'Ikpoba Okha',
      'Oredo', 'Orhionmwon', 'Ovia North East', 'Ovia South West',
      'Owan East', 'Owan West', 'Uhunmwonde'
    ]
  },
  {
    id: 'EKITI',
    name: 'Ekiti',
    lgas: [
      'Ado Ekiti', 'Efon', 'Ekiti East', 'Ekiti South West',
      'Ekiti West', 'Emure', 'Gbonyin', 'Ido Osi', 'Ijero',
      'Ikere', 'Ikole', 'Ilejemeje', 'Irepodun/Ifelodun',
      'Ise/Orun', 'Moba', 'Oye'
    ]
  },
  {
    id: 'ENUGU',
    name: 'Enugu',
    lgas: [
      'Aninri', 'Awgu', 'Enugu East', 'Enugu North', 'Enugu South',
      'Ezeagu', 'Igbo Etiti', 'Igbo Eze North', 'Igbo Eze South',
      'Isi Uzo', 'Nkanu East', 'Nkanu West', 'Nsukka', 'Oji River',
      'Udenu', 'Udi', 'Uzo Uwani'
    ]
  },
  {
    id: 'FCT',
    name: 'FCT Abuja',
    lgas: [
      'Abaji', 'Bwari', 'Gwagwalada', 'Kuje', 'Kwali',
      'Municipal Area Council'
    ]
  },
  {
    id: 'GOMBE',
    name: 'Gombe',
    lgas: [
      'Akko', 'Balanga', 'Billiri', 'Dukku', 'Funakaye',
      'Gombe', 'Kaltungo', 'Kwami', 'Nafada', 'Shongom',
      'Yamaltu/Deba'
    ]
  },
  {
    id: 'IMO',
    name: 'Imo',
    lgas: [
      'Aboh Mbaise', 'Ahiazu Mbaise', 'Ehime Mbano', 'Ezinihitte',
      'Ideato North', 'Ideato South', 'Ihitte/Uboma', 'Ikeduru',
      'Isiala Mbano', 'Isu', 'Mbaitoli', 'Ngor Okpala', 'Njaba',
      'Nkwerre', 'Nwangele', 'Obowo', 'Oguta', 'Ohaji/Egbema',
      'Okigwe', 'Onuimo', 'Orlu', 'Orsu', 'Oru East', 'Oru West',
      'Owerri Municipal', 'Owerri North', 'Owerri West'
    ]
  },
  {
    id: 'JIGAWA',
    name: 'Jigawa',
    lgas: [
      'Auyo', 'Babura', 'Biriniwa', 'Birnin Kudu', 'Buji',
      'Dutse', 'Gagarawa', 'Garki', 'Gumel', 'Guri', 'Gwaram',
      'Gwiwa', 'Hadejia', 'Jahun', 'Kafin Hausa', 'Kaugama',
      'Kazaure', 'Kiri Kasama', 'Kiyawa', 'Maigatari',
      'Malam Madori', 'Miga', 'Ringim', 'Roni', 'Sule Tankarkar',
      'Taura', 'Yankwashi'
    ]
  },
  {
    id: 'KADUNA',
    name: 'Kaduna',
    lgas: [
      'Birnin Gwari', 'Chikun', 'Giwa', 'Igabi', 'Ikara',
      'Jaba', "Jema'a", 'Kachia', 'Kaduna North', 'Kaduna South',
      'Kagarko', 'Kajuru', 'Kaura', 'Kauru', 'Kubau', 'Kudan',
      'Lere', 'Makarfi', 'Sabon Gari', 'Sanga', 'Soba',
      'Zangon Kataf', 'Zaria'
    ]
  },
  {
    id: 'KANO',
    name: 'Kano',
    lgas: [
      'Ajingi', 'Albasu', 'Bagwai', 'Bebeji', 'Bichi', 'Bunkure',
      'Dala', 'Dambatta', 'Dawakin Kudu', 'Dawakin Tofa', 'Doguwa',
      'Fagge', 'Gabasawa', 'Garko', 'Garun Mallam', 'Gaya',
      'Gezawa', 'Gwale', 'Gwarzo', 'Kabo', 'Kano Municipal',
      'Karaye', 'Kibiya', 'Kiru', 'Kumbotso', 'Kunchi', 'Kura',
      'Madobi', 'Makoda', 'Minjibir', 'Nasarawa', 'Rano',
      'Rimin Gado', 'Rogo', 'Shanono', 'Sumaila', 'Takai',
      'Tarauni', 'Tofa', 'Tsanyawa', 'Tudun Wada', 'Ungogo',
      'Warawa', 'Wudil'
    ]
  },
  {
    id: 'KATSINA',
    name: 'Katsina',
    lgas: [
      'Bakori', 'Batagarawa', 'Batsari', 'Baure', 'Bindawa',
      'Charanchi', 'Dan Musa', 'Dandume', 'Danja', 'Daura',
      'Dutsi', 'Dutsin Ma', 'Faskari', 'Funtua', 'Ingawa',
      'Jibia', 'Kafur', 'Kaita', 'Kankara', 'Kankia', 'Katsina',
      'Kurfi', 'Kusada', "Mai'Adua", 'Malumfashi', 'Mani',
      'Mashi', 'Matazu', 'Musawa', 'Rimi', 'Sabuwa', 'Safana',
      'Sandamu', 'Zango'
    ]
  },
  {
    id: 'KEBBI',
    name: 'Kebbi',
    lgas: [
      'Aleiro', 'Arewa Dandi', 'Argungu', 'Augie', 'Bagudo',
      'Birnin Kebbi', 'Bunza', 'Dandi', 'Danko Wasagu', 'Fakai',
      'Gwandu', 'Jega', 'Kalgo', 'Koko/Besse', 'Maiyama',
      'Ngaski', 'Sakaba', 'Shanga', 'Suru', 'Wasagu/Danko',
      'Yauri', 'Zuru'
    ]
  },
  {
    id: 'KOGI',
    name: 'Kogi',
    lgas: [
      'Adavi', 'Ajaokuta', 'Ankpa', 'Bassa', 'Dekina', 'Ibaji',
      'Idah', 'Igalamela Odolu', 'Ijumu', 'Kabba/Bunu', 'Kogi',
      'Lokoja', 'Mopa Muro', 'Ofu', 'Ogori/Magongo', 'Okehi',
      'Okene', 'Olamaboro', 'Omala', 'Yagba East', 'Yagba West'
    ]
  },
  {
    id: 'KWARA',
    name: 'Kwara',
    lgas: [
      'Asa', 'Baruten', 'Edu', 'Ekiti', 'Ifelodun', 'Ilorin East',
      'Ilorin South', 'Ilorin West', 'Irepodun', 'Isin', 'Kaiama',
      'Moro', 'Offa', 'Oke Ero', 'Oyun', 'Pategi'
    ]
  },
  {
    id: 'LAGOS',
    name: 'Lagos',
    lgas: [
      'Agege', 'Ajeromi-Ifelodun', 'Alimosho', 'Amuwo-Odofin',
      'Apapa', 'Badagry', 'Epe', 'Eti-Osa', 'Ibeju-Lekki',
      'Ifako-Ijaiye', 'Ikeja', 'Ikorodu', 'Kosofe', 'Lagos Island',
      'Lagos Mainland', 'Mushin', 'Ojo', 'Oshodi-Isolo',
      'Shomolu', 'Surulere'
    ]
  },
  {
    id: 'NASARAWA',
    name: 'Nasarawa',
    lgas: [
      'Akwanga', 'Awe', 'Doma', 'Karu', 'Keana', 'Keffi',
      'Kokona', 'Lafia', 'Nasarawa', 'Nasarawa Egon', 'Obi',
      'Toto', 'Wamba'
    ]
  },
  {
    id: 'NIGER',
    name: 'Niger',
    lgas: [
      'Agaie', 'Agwara', 'Bida', 'Borgu', 'Bosso', 'Chanchaga',
      'Edati', 'Gbako', 'Gurara', 'Katcha', 'Kontagora', 'Lapai',
      'Lavun', 'Magama', 'Mariga', 'Mashegu', 'Mokwa', 'Moya',
      'Paikoro', 'Rafi', 'Rijau', 'Shiroro', 'Suleja', 'Tafa',
      'Wushishi'
    ]
  },
  {
    id: 'OGUN',
    name: 'Ogun',
    lgas: [
      'Abeokuta North', 'Abeokuta South', 'Ado-Odo/Ota',
      'Egbado North', 'Egbado South', 'Ewekoro', 'Ifo',
      'Ijebu East', 'Ijebu North', 'Ijebu North East', 'Ijebu Ode',
      'Ikenne', 'Imeko Afon', 'Ipokia', 'Obafemi Owode', 'Odeda',
      'Odogbolu', 'Ogun Waterside', 'Remo North', 'Shagamu'
    ]
  },
  {
    id: 'ONDO',
    name: 'Ondo',
    lgas: [
      'Akoko North East', 'Akoko North West', 'Akoko South East',
      'Akoko South West', 'Akure North', 'Akure South', 'Ese Odo',
      'Idanre', 'Ifedore', 'Ilaje', 'Ile Oluji/Okeigbo', 'Irele',
      'Odigbo', 'Okitipupa', 'Ondo East', 'Ondo West', 'Ose', 'Owo'
    ]
  },
  {
    id: 'OSUN',
    name: 'Osun',
    lgas: [
      'Aiyedaade', 'Aiyedire', 'Atakunmosa East', 'Atakunmosa West',
      'Boluwaduro', 'Boripe', 'Ede North', 'Ede South', 'Egbedore',
      'Ejigbo', 'Ife Central', 'Ife East', 'Ife North', 'Ife South',
      'Ila', 'Ilesa East', 'Ilesa West', 'Irepodun', 'Irewole',
      'Isokan', 'Iwo', 'Obokun', 'Odo Otin', 'Ola Oluwa', 'Olorunda',
      'Oriade', 'Orolu', 'Osogbo'
    ]
  },
  {
    id: 'OYO',
    name: 'Oyo',
    lgas: [
      'Afijio', 'Akinyele', 'Atiba', 'Atisbo', 'Egbeda',
      'Ibadan North', 'Ibadan North East', 'Ibadan North West',
      'Ibadan South East', 'Ibadan South West', 'Ibarapa Central',
      'Ibarapa East', 'Ibarapa North', 'Ido', 'Irepo', 'Iseyin',
      'Itesiwaju', 'Iwajowa', 'Kajola', 'Lagelu', 'Ogbomosho North',
      'Ogbomosho South', 'Ogo Oluwa', 'Olorunsogo', 'Oluyole',
      'Ona Ara', 'Orelope', 'Ori Ire', 'Oyo', 'Oyo East',
      'Saki East', 'Saki West', 'Surulere'
    ]
  },
  {
    id: 'PLATEAU',
    name: 'Plateau',
    lgas: [
      'Barkin Ladi', 'Bassa', 'Bokkos', 'Jos East', 'Jos North',
      'Jos South', 'Kanam', 'Kanke', 'Langtang North',
      'Langtang South', 'Mangu', 'Mikang', 'Pankshin',
      "Qua'an Pan", 'Riyom', 'Shendam', 'Wase'
    ]
  },
  {
    id: 'RIVERS',
    name: 'Rivers',
    lgas: [
      'Abua/Odual', 'Ahoada East', 'Ahoada West', 'Akuku-Toru',
      'Andoni', 'Asari-Toru', 'Bonny', 'Degema', 'Eleme', 'Emohua',
      'Etche', 'Gokana', 'Ikwerre', 'Khana', 'Obio/Akpor',
      'Ogba/Egbema/Ndoni', 'Ogu/Bolo', 'Okrika', 'Omuma',
      'Opobo/Nkoro', 'Oyigbo', 'Port Harcourt', 'Tai'
    ]
  },
  {
    id: 'SOKOTO',
    name: 'Sokoto',
    lgas: [
      'Binji', 'Bodinga', 'Dange Shuni', 'Gada', 'Goronyo',
      'Gudu', 'Gwadabawa', 'Illela', 'Isa', 'Kebbe', 'Kware',
      'Rabah', 'Sabon Birni', 'Shagari', 'Silame', 'Sokoto North',
      'Sokoto South', 'Tambuwal', 'Tangaza', 'Tureta', 'Wamako',
      'Wurno', 'Yabo'
    ]
  },
  {
    id: 'TARABA',
    name: 'Taraba',
    lgas: [
      'Ardo Kola', 'Bali', 'Donga', 'Gashaka', 'Gassol', 'Ibi',
      'Jalingo', 'Karim Lamido', 'Kumi', 'Lau', 'Sardauna',
      'Takum', 'Ussa', 'Wukari', 'Yorro', 'Zing'
    ]
  },
  {
    id: 'YOBE',
    name: 'Yobe',
    lgas: [
      'Bade', 'Bursari', 'Damaturu', 'Fika', 'Fune', 'Geidam',
      'Gujba', 'Gulani', 'Jakusko', 'Karasuwa', 'Machina',
      'Nangere', 'Nguru', 'Potiskum', 'Tarmuwa', 'Yunusari',
      'Yusufari'
    ]
  },
  {
    id: 'ZAMFARA',
    name: 'Zamfara',
    lgas: [
      'Anka', 'Bakura', 'Birnin Magaji/Kiyaw', 'Bukkuyum',
      'Bungudu', 'Gummi', 'Gusau', 'Kaura Namoda', 'Maradun',
      'Maru', 'Shinkafi', 'Talata Mafara', 'Tsafe', 'Zurmi'
    ]
  }
];

// ============================================
// HELPER FUNCTIONS
// ============================================

/**
 * Get LGAs for a specific state
 * @param {string} stateName - The name of the state
 * @returns {string[]} Array of LGA names
 */
export const getLGAsByState = (stateName) => {
  const state = NIGERIAN_STATES.find(s => s.name === stateName);
  return state ? state.lgas : [];
};

/**
 * Get state by LGA name
 * @param {string} lgaName - The name of the LGA
 * @returns {string|null} State name or null if not found
 */
export const getStateByLGA = (lgaName) => {
  for (const state of NIGERIAN_STATES) {
    if (state.lgas.includes(lgaName)) {
      return state.name;
    }
  }
  return null;
};

/**
 * Search states by query
 * @param {string} query - Search query
 * @returns {Array} Array of matching states
 */
export const searchStates = (query) => {
  const lowerQuery = query.toLowerCase();
  return NIGERIAN_STATES.filter(state =>
    state.name.toLowerCase().includes(lowerQuery)
  );
};

/**
 * Search LGAs by query
 * @param {string} query - Search query
 * @param {string|null} stateName - Optional state name to filter by
 * @returns {Array} Array of matching LGAs with state info
 */
export const searchLGAs = (query, stateName = null) => {
  const lowerQuery = query.toLowerCase();
  let states = NIGERIAN_STATES;
  if (stateName) {
    const state = NIGERIAN_STATES.find(s => s.name === stateName);
    states = state ? [state] : [];
  }

  const results = [];
  for (const state of states) {
    const matchingLGAs = state.lgas.filter(lga =>
      lga.toLowerCase().includes(lowerQuery)
    );
    for (const lga of matchingLGAs) {
      results.push({ state: state.name, lga });
    }
  }
  return results;
};

/**
 * Get state object by name
 * @param {string} stateName - The name of the state
 * @returns {Object|null} State object or null if not found
 */
export const getStateByName = (stateName) => {
  return NIGERIAN_STATES.find(s => s.name === stateName) || null;
};

/**
 * Get state ID by name
 * @param {string} stateName - The name of the state
 * @returns {string|null} State ID or null if not found
 */
export const getStateIdByName = (stateName) => {
  const state = NIGERIAN_STATES.find(s => s.name === stateName);
  return state ? state.id : null;
};

/**
 * Get state name by ID
 * @param {string} stateId - The ID of the state
 * @returns {string|null} State name or null if not found
 */
export const getStateNameById = (stateId) => {
  const state = NIGERIAN_STATES.find(s => s.id === stateId);
  return state ? state.name : null;
};

/**
 * Get all state names
 * @returns {string[]} Array of all state names
 */
export const getStateNames = () => {
  return NIGERIAN_STATES.map(state => state.name);
};

/**
 * Get all states with their IDs and names
 * @returns {Array} Array of state objects with id, name, and lgas
 */
export const getStatesWithIds = () => {
  return NIGERIAN_STATES.map(state => ({
    id: state.id,
    name: state.name,
    lgas: state.lgas
  }));
};

/**
 * Get total number of states
 * @returns {number} Total number of states
 */
export const getTotalStates = () => {
  return NIGERIAN_STATES.length;
};

/**
 * Get total number of LGAs across all states
 * @returns {number} Total number of LGAs
 */
export const getTotalLGAs = () => {
  let total = 0;
  for (const state of NIGERIAN_STATES) {
    total += state.lgas.length;
  }
  return total;
};

/**
 * Get states with their LGA counts
 * @returns {Array} Array of states with lgaCount property
 */
export const getStatesWithCounts = () => {
  return NIGERIAN_STATES.map(state => ({
    ...state,
    lgaCount: state.lgas.length,
  }));
};

/**
 * Get all LGAs across all states with their state info
 * @returns {Array} Array of objects containing state and LGA info
 */
export const getAllLGAs = () => {
  const allLGAs = [];
  for (const state of NIGERIAN_STATES) {
    for (const lga of state.lgas) {
      allLGAs.push({
        state: state.name,
        stateId: state.id,
        lga: lga,
      });
    }
  }
  return allLGAs;
};

/**
 * Validate if a state exists
 * @param {string} stateName - The name of the state
 * @returns {boolean} True if state exists
 */
export const isValidState = (stateName) => {
  return NIGERIAN_STATES.some(state => state.name === stateName);
};

/**
 * Validate if an LGA exists for a state
 * @param {string} stateName - The name of the state
 * @param {string} lgaName - The name of the LGA
 * @returns {boolean} True if LGA exists for the state
 */
export const isValidLGA = (stateName, lgaName) => {
  const state = NIGERIAN_STATES.find(s => s.name === stateName);
  return state ? state.lgas.includes(lgaName) : false;
};

export default NIGERIAN_STATES;